import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { SettingProvider } from "../contexts/SettingContext";
import { DialogProvider } from "../contexts/DialogContext";
import { FormProvider } from "../contexts/SettingFormContext";
import { CountryProvider } from "../contexts/CountryContext";
import { SmsProviderProvider } from "../contexts/SmsProviderContext";
import { StateMasterProvider } from "../contexts/StateMasterContext";
import { PincodeProvider } from "../contexts/PincodeContext";

export const SettingComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <SettingProvider key={0} />,
        <FormProvider key={1} />,
        <CountryProvider key={2} />,
        <SmsProviderProvider key={3} />,
        <StateMasterProvider key={4} />,
        <PincodeProvider key={5} />,
        <DialogProvider key={6} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
